export { default as SetPasswordRoute } from "./SetPassword";
